import { render, staticRenderFns } from "./ShippingLogBLDetailBLBodyPop.vue?vue&type=template&id=123c7bc2"
import script from "./ShippingLogBLDetailBLBodyPop.vue?vue&type=script&lang=js"
export * from "./ShippingLogBLDetailBLBodyPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('123c7bc2')) {
      api.createRecord('123c7bc2', component.options)
    } else {
      api.reload('123c7bc2', component.options)
    }
    module.hot.accept("./ShippingLogBLDetailBLBodyPop.vue?vue&type=template&id=123c7bc2", function () {
      api.rerender('123c7bc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/ShippingLogBLDetailBLBodyPop.vue"
export default component.exports